// EC-849-Create a custom redux store to store the data
import { ApiParameter, get, HasPagingParameters, post } from "@insite/client-framework/Services/ApiService";
import { GetProductApiV2ParameterBase, GetProductCollectionRealTimeInventoryApiV2Parameter, GetProductCollectionRealTimePriceApiV2Parameter, GetProductRealTimeInventoryApiV2Parameter, ProductFilterTokens } from "@insite/client-framework/Services/ProductServiceV2";
import {
    AttributeTypeFacetModel,
    BaseModel,
    CategoryFacetModel,
    FacetModel,
    PriceRangeModel,
    ProductModel,
    RealTimePricingModel,
    SuggestionModel,
} from "@insite/client-framework/Types/ApiModels";

const realTimePricingUrl = "/api/v1/realtimepricing";
const productsUrl = "/api/v2/catalogviewproducts";

export type ProductExpandTokens = (
    | "detail"
    | "content"
    | "images"
    | "documents"
    | "specifications"
    | "properties"
    | "attributes"
    | "variantTraits"
    | "facets"
    | "badges"
    | "warehouses"
    | "scoreexplanation"
)[];

export interface GetProductCollectionApiV2Parameter extends GetProductApiV2ParameterBase, HasPagingParameters {
    search?: string;
    categoryId?: string;
    productIds?: string[];
    names?: string[];
    searchWithin?: string;
    brandIds?: string[];
    makeBrandUrls?: boolean;
    productLineIds?: string[];
    attributeValueIds?: string[];
    priceFilters?: string[];
    filter?: ProductFilterTokens;
    topSellersCategoryIds?: string[];
    topSellersPersonaIds?: string[];
    /** @deprecated Use pageSize instead. */
    topSellersMaxResults?: number;
    includeSuggestions?: boolean;
    applyPersonalization?: boolean;
    stockedItemsOnly?: boolean;
    previouslyPurchasedProducts?: boolean;
    cartId?: string;
    extendedNames?: string[];
    productNumbers?: string[];
    relevancy?: boolean;
}



export interface ProductCollectionModel extends BaseModel {
    attributeTypeFacets: AttributeTypeFacetModel[] | null;
    brandFacets: FacetModel[] | null;
    categoryFacets: CategoryFacetModel[] | null;
    correctedQuery: string;
    didYouMeanSuggestions: SuggestionModel[] | null;
    exactMatch: boolean;
    notAllProductsAllowed: boolean;
    notAllProductsFound: boolean;
    originalQuery: string;
    priceRange: PriceRangeModel | null;
    productLineFacets: FacetModel[] | null;
    products: ProductModel[] | null;
    searchTermRedirectUrl: string;
}

export function getProductCollectionV2(parameter: GetProductCollectionApiV2Parameter) {
    return get<ProductCollectionModel>(productsUrl, parameter);
}


export function getProductCollectionRealTimePrices(parameter: any) {
    return post<GetProductCollectionRealTimePriceApiV2Parameter, RealTimePricingModel>(`${realTimePricingUrl}`, {
        productPriceParameters: parameter,
    });
}


